exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".braveCheckbox{position:relative;height:25px;width:25px}.braveCheckbox.withLabel{width:100%;height:auto}.braveCheckbox.withLabel .checkedImg{margin-right:1.5em}.braveCheckbox:hover{opacity:.7;cursor:pointer}.braveCheckbox:hover.disabled{opacity:1;cursor:default}.braveCheckbox .checkedImg,.braveCheckbox .uncheckedImg{position:absolute;left:0;bottom:0;height:auto}.braveCheckbox .checkedImg{width:36px}.braveCheckbox .uncheckedImg{width:25px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/utility/brave_checkbox.scss
// module id = 893
// module chunks = 0